module.exports = __webpack_public_path__ + "static/img/return-top.c4c9431f.png";